import { useTranslation } from 'next-i18next';
import { type UserVoucherResDisplayStatus } from '@/api';
import { Button } from '@/ui_v3/components/button';
import { VOUCHER_STATUS_LABELS } from './type';
export const VoucherActionButton = ({
  status,
  onUse,
  isDisabled
}: {
  status: UserVoucherResDisplayStatus;
  onUse: () => void;
  isDisabled: boolean;
}) => {
  const {
    t
  } = useTranslation(['billing']);
  // 사용중인 이용권
  if (status === 'IN_USE') {
    return <span className="px-sm text-body-sm-semibold text-neutral opacity-[0.54]">
        {t('voucher.action.used')}
      </span>;
  }

  // 미사용 이용권
  if (status === 'UNUSED') {
    return <Button variant="contained" intent="alternative" size="sm" rounded="full" disabled={isDisabled} onClick={onUse}>
        {!isDisabled ? t('voucher.action.activate') : t('voucher.action.deactivated')}
      </Button>;
  }

  // 사용 완료 또는 기간 만료
  return <span className="px-sm text-body-sm-semibold text-neutral opacity-[0.54]" data-sentry-component="VoucherActionButton" data-sentry-source-file="VoucherActionButton.tsx">
      {t(VOUCHER_STATUS_LABELS[status])}
    </span>;
};